export default Object.freeze({
  Therapy: 1,
  Appointment: 2,
  Consulting: 3,
  EducationalService: 8,
});
